import styled from 'styled-components';

export const PaymentsListRoot = styled.div<{ isMobile: boolean }>`
  max-width: 1080px;
  margin: ${({ isMobile }) => (isMobile ? '0' : '24px auto')};
`;

export const ModalContentActions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  padding: ${({ theme }) => theme.spacers.XL} 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;

  > svg {
    flex-shrink: 0;
    display: block;
  }
`;

export const DownloadInvoiceDisabled = styled.div`
  padding-right: ${({ theme }) => theme.spacers.S};
  width: 100%;
  display: flex;
  align-items: center;
  opacity: 0.5;

  &:not(:last-child) {
    ${Content} {
      border-bottom: 2px solid ${({ theme }) => theme.colors.stroke.lighterGrey};
    }
  }
`;

export const IconCircle = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  background: ${({ theme }) => theme.colors.hover.lighterGrey};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`;

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.text.baseGrey};
`;
